import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    Container,
    Grid,
    Paper,
    Button,
    CircularProgress,
    Box
} from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { RequestInsert } from 'Components/Api/OverdraftApi';
import { SelectLast10Request as TRANSACTION_LAST10 } from 'Components/Api/OverdraftApi';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import ReactTable from 'Components/ReactTable/ReactTable';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const OverdraftRequest = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');

    const [currentUserID] = useState(parseInt(localStorage.getItem('UserID')));
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);

    const [formObj] = useState({
        Amount: '',
        Remark: '',
        InWords: ''
    });

    const validationSchema = Yup.object({
        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + 'amount')
            .required(PLEASE_PROVIDE_VALID + 'amount'),

        Remark: Yup.string().required(PLEASE_PROVIDE_VALID + 'remark')
    });

    const Select = async () => {
        createColumns();

        setTransactions([]);

        setLoadingOpen(true);

        var response = await TRANSACTION_LAST10();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) return;

        var data = JSON.parse(response.data);
        setTransactions(data);
    };

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;

        setFieldValue('InWords', NumberToWord(value));
    };

    useEffect(() => {
        Select();
        createColumns();
    }, [currentUserID]);

    const handleSubmit = async (values, { setSubmitting }) => {
        setLoadingOpen(true);
        setResponseMessage('');
        setIsError(false);
        const { isAuthorized, status, data } = await RequestInsert(
            JSON.stringify(values)
        );
        setLoadingOpen(false);
        if (!isAuthorized) LOGOUT();

        if (!status) {
            setSeverity('error');
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        setSeverity('success');
        setResponseMessage(data);
        setIsError(true);

        setSubmitting(false);
        setTimeout(() => {
            history.push('/OverdraftRequestReport');
        }, MESSAGE_CLOSE_AFTER);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'FundTransactionID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'Wallet',
            name: 'Wallet'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount',
            numeric: true
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });

        columns.push({
            label: 'R.Remark',
            name: 'UserRemark'
        });
        columns.push({
            label: 'S.Remark',
            name: 'AdminRemark'
        });

        setMainColumns(columns);
    };
    const UploadForm = (formProps) => {
        return (
            <Grid
                item
                container
                margin="normal"
                xs={12}
                md={12}
                sm={12}
                lg={12}
                spacing={2}
            >
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h2 className={classes.PaperHead_h2}>Overdraft Request</h2>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={6}
                    lg={6}
                    style={{
                        display: 'flex',
                        direction: 'rtl'
                    }}
                ></Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <Form>
                        <Paper className={classes.PaperStyle}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialCurrency
                                        name="Amount"
                                        label="Amount"
                                        placeholder="Amount"
                                        autoComplete="new-password"
                                        max={999999}
                                        onCustomCallback={(value) => {
                                            OnChange(
                                                value,
                                                formProps.setFieldValue
                                            );
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="Remark"
                                        name="Remark"
                                        type="text"
                                        length={50}
                                        title="Remark"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <MaterialTextField
                                        label="In words"
                                        name="InWords"
                                        type="text"
                                        readOnly={true}
                                        placeholder="InWords"
                                    />
                                </Grid>
                            </Grid>
                        </Paper>
                        <Grid className={classes.footerGrid}>
                            <Box className={classes.flexReverse}>
                                <div className={classes.SubmitWrapper}>
                                    <Button
                                        type="submit"
                                        title="Request"
                                        className={
                                            classes.CustomPrimaryButtonStyle
                                        }
                                        disabled={loadingOpen}
                                    >
                                        Request
                                    </Button>
                                    {loadingOpen && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </div>
                                <Button
                                    type="reset"
                                    variant="contained"
                                    color="secondary"
                                    title="Reset"
                                    className={classes.CustomDangerButtonStyle}
                                >
                                    Reset
                                </Button>
                            </Box>
                        </Grid>
                    </Form>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                    className="lastrecharges"
                >
                    <ReactTable
                        data={transactions}
                        columns={mainColumns}
                        headerToolbar={false}
                        footerToolbar={false}
                    />
                </Grid>
            </Grid>
        );
    };

    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                resetForm={formObj}
            >
                {UploadForm}
            </Formik>
        </CustomContainer>
    );
};
